// extracted by mini-css-extract-plugin
export var spinner = "spinner-module--spinner--d16b2";
export var spinner_wrapper = "spinner-module--spinner_wrapper--08187";
export var waiting = "spinner-module--waiting--064a4";